var _ellipse, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoPinActive2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 41,
    viewBox: "0 0 28 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 37.1538,
    rx: 7,
    ry: 3.84615,
    fill: "#646464",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8584 22.9413C26.8208 20.5454 28 17.4892 28 14.1574C28 6.46984 21.7321 0.239258 14.0015 0.239258C6.27098 0.239258 0 6.46984 0 14.1574C0 17.4892 1.17924 20.5454 3.14158 22.9413C3.14158 22.9413 3.15682 22.9625 3.18729 22.9959C3.19338 23.0019 3.19643 23.008 3.20252 23.014C3.67483 23.5956 6.96267 27.6665 8.7879 30.1018C10.2749 32.0828 12.3134 34.9542 13.3464 36.4202C13.6663 36.8746 14.3428 36.8746 14.6627 36.4202C15.6957 34.9572 17.7342 32.0858 19.2212 30.1018C21.0465 27.6665 24.3343 23.5986 24.8066 23.014C24.8127 23.008 24.8158 23.0019 24.8219 22.9959C24.8493 22.9595 24.8676 22.9413 24.8676 22.9413H24.8584Z",
    fill: "#009D4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4955 21.0819C15.8154 21.6752 14.2685 20.3119 14.0017 19.3218C13.7349 20.3152 12.1883 21.6752 10.5082 21.0819L14.0017 15.3779L17.4955 21.0819Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.505 15.0244L13.5084 15.021L9.16104 20.1052C8.07761 18.6918 8.89428 16.8014 9.75435 16.2413C8.72753 16.2945 6.95747 15.2444 7.00078 13.4642L13.505 15.0244Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9992 13.4642C21.0425 15.2444 19.2725 16.2946 18.2457 16.2413C19.1057 16.8014 19.9223 18.6914 18.839 20.1049L14.4919 15.021L20.9992 13.4642Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6949 14.4444L7.51754 11.884C8.52767 10.4172 10.5777 10.6106 11.3778 11.254C11.0111 10.2939 11.4613 8.28357 13.1682 7.77683L13.6949 14.4444Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8318 7.77344C16.5386 8.28019 16.9886 10.2905 16.6219 11.2506C17.422 10.6072 19.4723 10.4138 20.4825 11.8806L14.3051 14.441L14.8318 7.77344Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPinActive2);
export default __webpack_public_path__ + "static/media/ico-pin-active2.95670d5ce6c2e116b45500f9b02ae611.svg";
export { ForwardRef as ReactComponent };